import React from 'react'; import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Icon } from './../../../ui/src/component/icon';
import { TrafficItem } from './../trafficItem';

const Traffic = props => {
    return <div>
        <Link to="/dopravny-servis"><h2 className="h1 with-space">Dopravný servis <Icon name="chevron-circle-right" className="icon-md" /></h2></Link>
        <div className="row">
            {props.items.map(item => {
                return <div className="col-sm-6 col-md-3" key={item._id}>
                    <TrafficItem item={item} />
                </div>;
            })}
        </div>
    </div>;
};

Traffic.defaultProps = {
};

Traffic.propTypes = {
    items: PropTypes.array.isRequired
};

export default Traffic;



// WEBPACK FOOTER //
// ./src/app/component/traffic/traffic.js